/**
 * Thin client for one_armed_bandit_gm session APIs (Option B).
 */
import { ARCADE, API_PATH_PROXY_ENABLED } from '../../../utils/config';
import { acquireGmLease, endGmSession, noteGmState } from '../gmLease';

/** Lease key for this game's shared GM (game_engines/gm_registry.py). */
export const GM_GAME_ID = 'one_armed_bandit';

export const BANDIT_GM_BASE = API_PATH_PROXY_ENABLED
    ? (ARCADE.one_armed_bandit?.API_BASE || '')
    : '/bandit';

async function parseJson(res) {
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
        const err = new Error(data.error || `Bandit GM HTTP ${res.status}`);
        err.status = res.status;
        err.data = data;
        throw err;
    }
    return noteGmState(GM_GAME_ID, data);
}

export async function createBanditSession() {
    await acquireGmLease(GM_GAME_ID);
    const res = await fetch(`${BANDIT_GM_BASE}/session/create`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: '{}',
    });
    return parseJson(res);
}

export async function moveBanditSession(sessionId, { bet = 1 } = {}) {
    const res = await fetch(`${BANDIT_GM_BASE}/session/${sessionId}/move`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ bet }),
    });
    return parseJson(res);
}

export async function deleteBanditSession(sessionId) {
    if (!sessionId) return;
    endGmSession(GM_GAME_ID, sessionId);
    try {
        await fetch(`${BANDIT_GM_BASE}/session/${sessionId}/delete`, { method: 'POST' });
    } catch {
        /* best-effort */
    }
}

export const SPIN_ENGAGEMENT = 1;
export const PAYOUT_SCORE_SCALE = 1;
export const INITIAL_CREDITS = 100;

export const spinScoreGain = (payout) => (
    SPIN_ENGAGEMENT + Math.max(0, Math.round(payout)) * PAYOUT_SCORE_SCALE
);
